<script lang="ts">
  import ProContent from './ProContent.svelte';
  import Head from '$lib/Head.svelte'
  export let data
 
</script>

<!-- <Head title="Data Visualization with Sveltekit and D3" /> -->

<div class="flex flex-col items-center pb-12">
  <!-- <CandlestickChart size="128" color="#71c4f9" strokeWidth="1px" /> -->
  <div class="w-[80px] sm:w-[140px]">
    <svg
      fill="#71c4f9"
      id="Warstwa_1"
      data-name="Warstwa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 331.33 302.75"
      ><rect x="174.93" y="15.81" width="87.26" height="87.26" /><rect
        x="506.44"
        y="400.21"
        width="87.26"
        height="87.26"
        transform="translate(-426.56 41.87) rotate(-30)" /><rect
        x="453.54"
        y="492.15"
        width="87.26"
        height="87.26"
        transform="translate(-493.75 405.82) rotate(-60)" /><rect
        x="69.14"
        y="199.68"
        width="87.26"
        height="87.26" /><rect
        x="294.31"
        y="400.53"
        width="87.26"
        height="87.26"
        transform="translate(-455.14 -64.15) rotate(-30)" /><rect
        x="347.2"
        y="308.6"
        width="87.26"
        height="87.26"
        transform="translate(-387.96 221.95) rotate(-60)" /></svg>
  </div>
  <!-- <img src={logo} class="mt-1" width="130px" alt="Superforms logo" /> -->
  <h1 class="mb-4 mt-4 ">
    Master Advanced Animations with Svelte 5 & D3 🚀
  </h1>
  <!-- <h4 class="mt-0">🏆 Svelte Hack 2023 winner - Best library! 🏆</h4> -->
</div>

Take your data visualizations to the next level with Pro Tutorials, where we
dive into advanced animations, interactive storytelling, and high-performance
visualizations using Svelte 5 and D3.js.

# Why Upgrade to Pro?

- Exclusive Tutorials: Learn techniques not covered in free content
- Advanced Animations: Smooth transitions, Spring animations and more with the latest Svelte 5 version
- Interactive Visuals: Create dashboards, tooltips, and animated user interactions

# Pro Tutorials

  <ProContent data={data} />

<br/>

### More Advanced Tutorials Coming soon!
